import Autocomplete, { AutocompleteProps, autocompleteClasses } from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import { styled, useTheme } from '@mui/material/styles';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';
import { useMemo } from 'react';
import _ from 'underscore';
import { FeedOption } from 'views/bluviu-nutrition/types/feed-option.type';

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`& .${autocompleteClasses.inputRoot}`]: {
    ...theme.typography.body2,
    paddingLeft: 12,
    height: '100%',
    color: theme.palette.darkBlue.main,
  },
})) as typeof Autocomplete;

export type Option = {
  id: string;
  label: string;
};

type Props = {
  params: GridRenderEditCellParams<Option>;
  options: FeedOption[];
};

const DataGridFeedAutocomplete = ({ params, options }: Props) => {
  const { id, value, field } = params;
  const theme = useTheme();
  const apiRef = useGridApiContext();

  const handleChange = React.useCallback<NonNullable<AutocompleteProps<Option, false, true, false>['onChange']>>(
    async (event, newValue) => {
      console.log(newValue);

      await apiRef.current.setEditCellValue({ id, field, value: newValue }, event);
      apiRef.current.stopCellEditMode({ id, field });
    },
    [apiRef, field, id]
  );

  const sortedOptions = useMemo(() => {
    return _.sortBy(options, (option) => option.label.toLowerCase() || '');
  }, [options]);

  return (
    <StyledAutocomplete<Option, false, true, false>
      value={value}
      onChange={handleChange}
      options={sortedOptions}
      getOptionLabel={(option: any) => option.label || ''}
      autoHighlight
      fullWidth
      open
      disableClearable
      renderOption={(optionProps, option: any) => {
        return (
          <Box component="li" {...optionProps} key={option.id}>
            {option.label}
          </Box>
        );
      }}
      popupIcon={<ChevronDown size={18} color={theme.palette.darkBlue.main} />}
      renderInput={(params) => (
        <InputBase
          autoFocus
          fullWidth
          id={params.id}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
          {...params.InputProps}
        />
      )}
    />
  );
};

export default DataGridFeedAutocomplete;
